module.exports = __webpack_public_path__ + "static/img/4001.b23da05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4001.png
// module id = 708
// module chunks = 0 1 12